import { ApolloProvider } from '@apollo/client';
import { CssBaseline } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router';
import { client } from 'client/client';
import { ErrorLoadingPage } from 'shared/ErrorLoadingPage';
import { LocalizedIntlProvider } from 'i18n/LocalizedIntlProvider';
import { LocaleProvider } from 'i18n/LocaleProvider';
import { ThemeProvider } from 'theme/ThemeProvider';
import { AppRouting } from 'components/routing/AppRouting';
import { SnackbarProvider } from '../../providers/SnackbarProvider';
import { AuthProvider } from '../../providers/AuthProvider';

export const App = () => {
  return (
    <ApolloProvider client={client}>
      <LocaleProvider>
        <BrowserRouter>
          <AuthProvider>
            <ThemeProvider>
              <CssBaseline />
              <SnackbarProvider>
                <ErrorBoundary fallback={<ErrorLoadingPage />}>
                  <LocalizedIntlProvider>
                    <AppRouting />
                  </LocalizedIntlProvider>
                </ErrorBoundary>
              </SnackbarProvider>
            </ThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </LocaleProvider>
    </ApolloProvider>
  );
};
